<template>
  <span style="">
    {{$t('prizes.percent-pott-text', {percent: percentString})}}
  </span>
</template>

<script>

export default {
  name: "PercentPottWidget",
  components: {},
  props: {
    percent: {
      type: Number,
      required: true
    },
  },
  computed: {
    percentString() {
      return parseFloat((this.percent * 100.0).toFixed(4));
    }
  }
};
</script>